<template>
  <footer>
    <div class="legal">
      <ul class="submenu">
        <template v-for="(page, index) in main_menu">
          <li :key="page.ItemID">
            <page-link :to="'/' + (page.url == 'default' ? '' : page.url)">{{page.name}}</page-link>
          </li>
          <li :key="page.ItemID + 'cats'" v-if="index == 0">
            <a href="#">Wooden Gates</a>
          </li>
        </template>
      </ul>
      <p>
        <strong>Wortley Brothers</strong>
        {{contact_info ? contact_info.address : ''}}
      </p>
      <p>
        <page-link to="/privacy-policy">Privacy Policy</page-link> |
        <page-link to="/terms-conditions">Terms &amp; Conditions</page-link> |
        &copy; Wortley Brothers Wooden Gates
      </p>
      <p><a href="https://chameleoncreative.marketing" rel="noreferrer" target="_blank">Website designed &amp; developed by Chameleon Creative</a></p>
    </div>
    <a class="sublogo" href>
      <img alt="KP Wooden Gates" src="../assets/logo.jpg" />
    </a>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    contact_info: function() {
      return this.$store.state.contact_info
    },
    main_menu: function() {
      return this.$store.getters.main_menu
    }
  }
}
</script>

<style scoped>
footer {
  clear: both;
  background: #f79227;
  padding: 5rem;
  color: #455051;
  font-size: 1.6rem;
  width: 100%;
  float: left;
  line-height: 1.2;
}

.sublogo img {
  height: 10rem;
  margin-left: -0.5rem;
}

.legal {
  float: right;
  text-align: right;
}

.legal p {
  padding: 0;
  margin: 0;
  margin-bottom: 1rem;
}

.submenu {
  list-style-type: none;
  color: white;
  margin-bottom: 4rem;
  font-size: 1.8rem;
}

.submenu li {
  display: inline-block;
  margin-left: 2rem;
}

@media screen and (max-width: 750px) {
  .legal {
    float: none;
    text-align: center;
  }

  .sublogo {
    text-align: center;
    display: block;
    margin-top: 5rem;
  }
}
</style>
